export default __webpack_public_path__ + "static/media/PaymentReceivedStamp.34ecf51c.jpg";